<div class="header-attribute m-r-6 m-b-6">
  <div class="title-height" fxLayout="row" fxLayoutAlign="space-between center">
    <div class="h3 pr-16 cardHeader">Atributos</div>
  </div>
  <div class="inner-card flow-root column" [formGroup]="this.createNewEmployeeFormGroup.get('Attributes')">
    <div>
      <div class="widget" fxFlex.gt-sm="50" fxFlex.gt-md="50" fxFlex.gt-lg="50"
        *ngFor="let control of attributeFormControls">
        <mat-form-field *ngIf="!control.Multiple && !control.Dropdown" class="example-full-width atributos-fields"
          floatLabel="always">
          <input matInput [placeholder]="control.label" [formControlName]="control.Name" [value]="control.value">
        </mat-form-field>

        <mat-form-field *ngIf="control.Dropdown" class="example-full-width atributos-fields" floatLabel="always">
          <mat-label>{{control.label}}</mat-label>
          <input matInput [formControlName]="control.Name" [matAutocomplete]="auto">
          <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
            <mat-option *ngFor="let option of control.Options" [(value)]="option.value">
              {{option.text}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>

        <mat-form-field *ngIf="control.Multiple" class="example-full-width atributos-fields" floatLabel="always">
          <input matInput [placeholder]="control.label" [formControlName]="control.Name" [value]="control.value"
            class="p-r-30">
          <button mat-icon-button (click)="openEditMultiAttributePopup(control.Name,control.value)">
            <mat-icon class="mat-icon material-icons mat-icon-no-color f-s-19 edit-icon">edit</mat-icon>
          </button>
        </mat-form-field>

        <mat-error
          *ngIf="(this.createNewEmployeeFormGroup.get(['Attributes',control.Name]) || !this.createNewEmployeeFormGroup.get(['Attributes',control.Name]).touched ) && this.createNewEmployeeFormGroup.get(['Attributes',control.Name]).invalid && control.Mandotory">
          <span *ngIf="this.createNewEmployeeFormGroup.get(['Attributes',control.Name]).errors.required"
            class="validation-span">Obligatorio</span>
        </mat-error>
      </div>
    </div>
  </div>
</div>